export const resultFields = [
  {
    label: 'Parent License plate',
    key: 'parent_license_plate',
  },
  {
    label: 'Child License Plate',
    key: 'child_license_plate',
  },
  {
    label: 'Domain Name',
    key: 'domain_name',
  },
].map((field) => ({
  ...field,
  isSortable: true,
  showErrorKey: field.key,
  thAttr: {
    style: 'min-width:180px;',
  },
}))
